import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Modal, Form, Row, Col, Input, Checkbox, Button} from 'antd'
import {withTranslation} from 'react-i18next'
const storage = window.localStorage

@inject('accountStore')
@observer
class FormModal extends Component {
  state = {
    checked: false,
  }
  formRef = React.createRef()

  componentDidMount() {
    const infos = JSON.parse(storage.getItem('accountInfos'))
    this.formRef.current.setFieldsValue({
      shortName: infos?.data?.name,
      // oldPassword: undefined,
      // password: undefined,
    })
  }

  handleOk = () => {
    const {accountStore, handleCancel} = this.props
    const infos = JSON.parse(storage.getItem('accountInfos'))
    this.formRef.current.validateFields().then(fieldsValue => {
      accountStore.onUpdatePwdByUser({
        "userId": infos?.data?.id,
        "oldPassword": fieldsValue.oldPassword,
        "password": fieldsValue.password
       }).then(response=> {
        if (response?.data?.code === 0) {
          handleCancel()
        }
      })
    }).catch(err => {
      console.log(err)
    })
  }

  render() {
    const {modalVisible, handleCancel, t} = this.props
    return (
      <>
        <Modal
          title={t(`home.changePassword`)}
          closable={true}
          onCancel={handleCancel}
          visible={modalVisible}
          // onOk={this.handleOk}
          // onCancel={handleCancel}
          maskClosable={false}
          destroyOnClose={true}
          centered
          footer={[
            <Button key="Save" type="primary" onClick={this.handleOk}>{t(`general.save`)}</Button>,
            <Button key="Cancel" onClick={handleCancel}>{t(`general.cancel`)}</Button>,
          ]}
        >
          <Form ref={this.formRef} key="addMapping" layout="vertical">
            <Row justify="start" gutter={[10, 10]}>
              <Col xs={24} sm={24} md={24} span={24}>
                <Form.Item name="shortName" label={t(`userManagement.userName`)}
                           rules={[{
                             required: true,
                            //  message: `${t(`general.pleaseEnter`)} ${t(`userManagement.userName`)} ${t(`general.withoutSpecialChats`)}`,
                            //  pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                           }]}>
                  <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} disabled/>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} span={24}>
                <Form.Item name="oldPassword" label={t(`userManagement.oldPassword`)}
                           rules={[{
                             required: true,
                             message: `${t(`general.pleaseEnter`)} ${t(`userManagement.password`)} ${t(`general.withoutSpecialChatsPassword`)}`,
                             pattern: new RegExp(/^(?=.*?\d)(?=.*?[a-zA-Z])[a-zA-Z\d!#@*.]{8,16}$/)
                           }]}>
                  <Input.Password placeholder={t(`general.pleaseEnter`)}/>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} span={24}>
                <Form.Item name="password" label={t(`userManagement.newPassword`)}
                           rules={[{
                             required: true,
                             message: `${t(`general.pleaseEnter`)} ${t(`userManagement.password`)} ${t(`general.withoutSpecialChatsPassword`)}`,
                             pattern: new RegExp(/^(?=.*?\d)(?=.*?[a-zA-Z])[a-zA-Z\d!#@*.]{8,16}$/)
                           }]}>
                  <Input.Password placeholder={t(`general.pleaseEnter`)}/>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(FormModal)
